import './App.css';
import Login from './Login';
import Todos from './Todos';
import { useAuthState } from 'react-firebase-hooks/auth'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { auth } from './firebase';
import Loading from './components/Loading';

function App() {
  return <div className="App">
    <ToastContainer />
    <ConditionalRenderer />
  </div>
}

const ConditionalRenderer = () => {
  const [user, loading] = useAuthState(auth);
  if (loading) return <Loading />;
  if (user) return <Todos />;
  return <Login />
}

export default App;
